import React from 'react';

import { appReactMemo } from 'hocs';

import { Container, Dot } from './styled';

export interface ILoaderProps {
  className?: string;
  size?: number;
}

const Loader = ({ className, size = 34 }: ILoaderProps): React.ReactElement => (
  <Container $size={size} className={className} data-testid='loader'>
    <Dot $delay='-0.48s' $size={size} />
    <Dot $delay='-0.32s' $size={size} />
    <Dot $delay='-0.16s' $size={size} />
    <Dot $delay='0s' $size={size} />
  </Container>
);

export default appReactMemo(Loader);
